import { render, staticRenderFns } from "./BellMsgView.vue?vue&type=template&id=5b48fcb0&scoped=true&"
import script from "./BellMsgView.vue?vue&type=script&lang=js&"
export * from "./BellMsgView.vue?vue&type=script&lang=js&"
import style0 from "./BellMsgView.vue?vue&type=style&index=0&id=5b48fcb0&lang=scss&scoped=true&"
import style1 from "./BellMsgView.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b48fcb0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b48fcb0')) {
      api.createRecord('5b48fcb0', component.options)
    } else {
      api.reload('5b48fcb0', component.options)
    }
    module.hot.accept("./BellMsgView.vue?vue&type=template&id=5b48fcb0&scoped=true&", function () {
      api.rerender('5b48fcb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/sysMsgConfig/BellMsgView.vue"
export default component.exports